export default __webpack_public_path__ + "static/9_brawler-punch-9ca73e0de7ef67c71839ee0fd4a91fba.png";